import { render, staticRenderFns } from "./PostCreate.vue?vue&type=template&id=175f1460"
import script from "./PostCreate.vue?vue&type=script&lang=js"
export * from "./PostCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('175f1460')) {
      api.createRecord('175f1460', component.options)
    } else {
      api.reload('175f1460', component.options)
    }
    module.hot.accept("./PostCreate.vue?vue&type=template&id=175f1460", function () {
      api.rerender('175f1460', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/web-components/community/PostCreate.vue"
export default component.exports